import { Component, Input, OnInit } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-image',
    templateUrl: './image.page.html',
    styleUrls: ['./image.page.scss'],
})
export class ImagePage implements OnInit
{
    @Input() value: any;
    public image: any;

    constructor(
        private nav: NavController,
        private modalCtrl: ModalController,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit()
    {
        if (this.value)
            this.image = this.sanitizer.bypassSecurityTrustStyle(this.value);
        else
            this.nav.navigateRoot('/login');
    }

    closeModal()
    {
        this.modalCtrl.dismiss();
    }

}
